import React from 'react'
import StencilBox from '../../stencils/StencilBox'
import SEO from '../../../common/SEO'
import Layout from '../../../common/Layout'
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne'

function InterviewSeriesStencil({ data }) {
    return (
        <div>
            <SEO title="Interview Q&A Series | Longswitch Academy" /> {/* Set SEO title */}
            <Layout>
                <BreadcrumbOne
                    title="Interview Q&A Series" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Interview Q&A Series"
                />
                <div className="edu-elements-area edu-section-gap bg-color-white">
                    <div className="container mb--80">
                        <div className="row g-5">
                            <div className="col-lg-12">
                                <div className="row y-gap-30 g-5">
                                    {
                                        (data || [])?.map((item) => (
                                            <div className="col-lg-4 col-md-6 col-12" key={item.id}>
                                                {/* Render individual post */}

                                                <div className="edu-card card-type-2 radius-small placeholder">
                                                    <div className="inner">
                                                        <div className="thumbnail">
                                                            <StencilBox
                                                                className="sf-img-stencil bg-secondary"
                                                                width="335px"
                                                                height="190px"
                                                                backgroundColor="#F5F5F5"
                                                            />
                                                            <div className="top-position status-group left-top">
                                                            </div>

                                                        </div>
                                                        <div className="content">
                                                            <ul className="edu-meta meta-01 mt--20">
                                                                <li>
                                                                    <StencilBox
                                                                        className="bg-secondary"
                                                                        width="140px"
                                                                        height="26px"
                                                                        backgroundColor="#F5F5F5"
                                                                    />
                                                                </li>
                                                                <li>
                                                                    <StencilBox
                                                                        className="bg-secondary"
                                                                        width="140px"
                                                                        height="26px"
                                                                        backgroundColor="#F5F5F5"
                                                                    />
                                                                </li>
                                                            </ul>
                                                            <div className="cl-lg-12 d-flex justify-content-center edu-rating rating-default mt--10">
                                                                <StencilBox
                                                                    className="bg-secondary"
                                                                    width="100%"
                                                                    height="44px"
                                                                    backgroundColor="#F5F5F5"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default InterviewSeriesStencil
